






import { mapState } from "vuex";
import { Component, Watch, Vue } from "vue-property-decorator";
import { CalendarOptions } from "@fullcalendar/core";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import bsPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import enGbLocale from "@fullcalendar/core/locales/en-gb";
import { ScheduleDateFilter } from "@/store/modules/types";

@Component({
  components: {
    FullCalendar,
  },
  computed: {
    ...mapState("schedule", ["view", "list"]),
  },
})
export default class CalendarView extends Vue {
  @Watch("list.filter", { deep: true })
  onFilterChanged() {
    this.refreshEvents();
  }

  options: CalendarOptions = {
    plugins: [
      dayGridPlugin,
      timeGridPlugin,
      bsPlugin,
      listPlugin,
      interactionPlugin,
    ],
    locale: enGbLocale,
    events: this.eventSource,
    eventClick: this.eventClick,
    dateClick: this.dateClick,
    headerToolbar: {
      left: "prev,next today",
      center: "title",
      right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
    },
    buttonText: {
      today: "Today",
      month: "Month",
      week: "Week",
      day: "Day",
      list: "Schedule",
    },
    initialView: "dayGridMonth",
    themeSystem: "bootstrap",
    firstDay: 1, // Start on Monday
    height: "auto",
    dayMaxEvents: 3, // Collapse extra events into "+X more"
    eventDisplay: 'block',
    eventTimeFormat: { 
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    meridiem: 'short',
    omitZeroMinute: true // Remueve automáticamente el :00 (ej. "9 AM" en vez de "9:00 AM")
  }
  };

  eventSource(info: any, success: Function, failure: Function) {
    const dateFilter: ScheduleDateFilter = {
      timeSpan: null,
      from: info.startStr,
      to: info.endStr,
    };
    this.$store.commit("main/SET_LOADING", true);
    this.$store
      .dispatch("schedule/getCalendarViewEvents", dateFilter)
      .then((events) => success(events))
      .catch((error) => failure(error))
      .finally(() => this.$store.commit("main/SET_LOADING", false));
  }

  eventClick(info: any) {
    this.$emit("new-appt", info.event);
  }

  dateClick(info: any) {
    console.log(info);
  }

  refreshEvents() {
    const fullCalendar = (
      this.$refs.fullCalendar as InstanceType<typeof FullCalendar>
    ).getApi();
    fullCalendar.refetchEvents();
  }
}
